export const zh = {
  title: '开发管理',
  nav: {
    overview: '总览',
    items: '需求',
    gantt: '甘特图',
    updates: '更新记录',
  },
  dashboard: {
    title: '开发管理总览',
    subtitle: '一屏掌握需求、开发与测试进度',
    gantt: '甘特图计划',
    requirements: '需求列表',
    development: '开发列表',
    testing: '测试列表',
    completed: '已完成',
    viewAll: '查看全部',
  },
  items: {
    title: '需求列表',
    subtitle: '统一记录需求与研发进度',
    createTitle: '新建需求',
  },
  gantt: {
    title: '需求甘特图',
    subtitle: '以需求排期视角掌握未来计划',
    dueAt: '预计完成',
    days: '天',
    toolbar: {
      view: '视图',
      today: '今天',
      prev: '上一屏',
      next: '下一屏',
    },
    views: {
      day: '日',
      week: '周',
      month: '月',
      quarter: '季',
      year: '年',
    },
    segments: {
      dev: 'Dev',
      test: 'Test',
    },
  },
  updates: {
    title: '更新记录',
    subtitle: '记录每次版本更新的说明',
    empty: '暂无更新记录',
    formTitle: '新增更新记录',
    fields: {
      version: '版本号',
      title: '更新标题',
      releasedAt: '发布日期',
      content: '更新内容',
    },
    placeholders: {
      version: '例如 v1.2.0',
      title: '请输入更新标题',
    },
    actions: {
      create: '新增记录',
      save: '保存记录',
      cancel: '取消',
    },
  },
  fields: {
    title: '标题',
    description: '描述',
    priority: '优先级',
    moduleKey: '模块',
    owner: '负责人',
    itemType: '类型',
    severity: '严重级别',
    parentId: '所属模块',
    labels: '标签',
  },
  status: {
    DRAFT: '需求提出',
    REVIEWED: '已评审',
    IN_DEVELOPMENT: '开发中',
    IN_TESTING: '测试中',
    USER_TESTING: '用户测试',
    DONE: '已完成',
    CANCELLED: '已取消',
    ARCHIVED: '已归档',
  },
  itemType: {
    MODULE: '模块需求',
    FEATURE: '功能需求',
    BUG: 'Bug 需求',
  },
  priority: {
    P0: 'P0 · 紧急',
    P1: 'P1 · 高',
    P2: 'P2 · 中',
    P3: 'P3 · 低',
  },
  filters: {
    keyword: '关键词搜索',
    status: '状态',
    priority: '优先级',
    itemType: '类型',
    all: '全部',
  },
  table: {
    title: '标题',
    type: '类型',
    priority: '优先级',
    status: '状态',
    owner: '负责人',
    updatedAt: '更新时间',
    actions: '操作',
  },
  empty: {
    items: '暂无需求',
    gantt: '暂无可排期需求',
    description: '暂无描述',
  },
  loading: '加载中...',
  actions: {
    refresh: '刷新',
    createItem: '创建需求',
    applyFilters: '应用筛选',
    selectOwner: '选择负责人',
    cancel: '取消',
    confirm: '确认',
  },
  toast: {
    loadFailed: '加载失败，请稍后重试',
    createFailed: '创建失败，请检查输入',
    releaseNoteCreateFailed: '更新记录创建失败',
    releaseNoteCreated: '更新记录已创建',
    updateFailed: '更新失败，请稍后重试',
    created: '创建成功',
    statusUpdated: '状态已更新',
    requiredFields: '请填写必填字段',
    contentRequired: '请填写需求文档',
  },
  detail: {
    section: '需求详情',
    metaTitle: '关键信息',
    stageTitle: '阶段轨迹',
    documentTitle: '需求文档',
    save: '保存文档',
    saving: '保存中...',
    contentPlaceholder: '输入需求背景、范围与验收标准...',
    groups: {
      progress: '进度',
      people: '人员',
      timeline: '时间',
    },
    timeline: {
      edit: '调整',
      set: '设置',
      save: '保存',
      cancel: '取消',
    },
    labels: {
      code: '编号',
      status: '状态',
      priority: '优先级',
      moduleKey: '模块标识',
      owner: '负责人',
      reporter: '创建人',
      reviewer: '评审人',
      createdAt: '需求提出',
      reviewedAt: '评审时间',
      startAt: '开始时间',
      devEtaAt: '预计开发完成',
      devCompletedAt: '开发完成时间',
      testEtaAt: '预计测试结束',
      testCompletedAt: '测试完成时间',
      etaAt: '预计完成',
      completedAt: '完成时间',
    },
    actions: {
      REVIEWED: '确认评审完成',
      IN_DEVELOPMENT: '进入开发阶段',
      IN_TESTING: '进入测试阶段',
      USER_TESTING: '进入用户测试',
      DONE: '确认完成',
      ARCHIVED: '归档',
      CANCELLED: '取消需求',
    },
  },
  create: {
    title: '新建需求',
    back: '返回需求列表',
    submit: '提交需求',
    centerTitle: '创建新需求',
    defaultTitle: '未命名需求',
    titlePlaceholder: '请输入需求标题',
    titleRequired: '请填写需求标题',
    contentHint: '请输入具体的描述',
    contentPlaceholder: '输入需求背景、范围与验收标准...',
    saving: '创建中...',
    modulePlaceholder: '选择所属模块',
    moduleEmpty: '暂无模块需求',
    moduleKeyPlaceholder: '输入英文模块名',
    ownerTitle: '选择负责人',
  },
};
